import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'design-system-web';
import { ICON_SET_FONTAWESOME } from 'constants-activate';
import { LegacyButton } from '../Button/Button';
import styles from './WorkOrderErrorState.scss';

type Props = {
  onTryAgain?: () => void;
};

export const WorkOrderErrorState: React.FC<Props> = ({ onTryAgain }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.errorBlock}>
      <div className={styles.iconWrapper}>
        <Icon
          set={ICON_SET_FONTAWESOME}
          name="exclamation-circle"
          type="fal"
          size="large"
        />
      </div>
      <div className={styles.title}>{t('shared.integrations.vantify.workorder.errorState.title')}</div>
      <div className={styles.subTitle}>
        {t('shared.integrations.vantify.workorder.errorState.subtitle')}
      </div>
      {onTryAgain && (
        <LegacyButton
          className={styles.tryAgainButton}
          variant="contained"
          size="medium"
          onClick={onTryAgain}
        >
          {t('shared.integrations.vantify.workorder.errorState.tryAgain')}
        </LegacyButton>
      )}
    </div>
  );
};

